import { T_FormValidationCheckParams, T_ValidationContext } from "@/types/form.type";

type T_Props = {
    ctxFormData: T_ValidationContext;
    validationCheck: (params: T_FormValidationCheckParams) => void;
};

export const createKeyDownHandler = ({ ctxFormData, validationCheck }: T_Props) => {
    return (
        e: React.KeyboardEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        if (e.key !== 'Tab') return;

        e.preventDefault();

        const target = e.currentTarget;
        const form = target.form;
        const formName = form?.name;
        const ctxForm = formName ? ctxFormData[formName]?.data : null;

        // Run validation for all elements (or customize by type if needed)
        validationCheck({ target, ctxForm });

        const focusable = form
            ? Array.from(
                form.querySelectorAll<HTMLElement>(
                    'input, select, textarea, button, [tabindex]:not([tabindex="-1"])'
                )
            ).filter(
                el =>
                    !el.hasAttribute('disabled') &&
                    el.tabIndex !== -1 &&
                    el.offsetParent !== null
            )
            : [];

        const index = focusable.indexOf(target);
        const next = e.shiftKey ? focusable[index - 1] : focusable[index + 1];

        next?.focus();
    };
};
